import { z } from 'zod';

// ---------------------------------------------------------------------------
// Params & Queries
// ---------------------------------------------------------------------------

export const contactIdParam = z.object({
  id: z.string().uuid(),
});

export const listContactsQuery = z.object({
  hub_id: z.string().uuid(),
  search: z.string().optional(),
  tags: z.string().optional(), // comma-separated
  page: z.coerce.number().int().min(1).default(1),
  per_page: z.coerce.number().int().min(1).max(100).default(25),
});

export const createContactBody = z.object({
  hub_id: z.string().uuid(),
  contact_name: z.string().min(1),
  phone: z.string().optional(),
  email: z.string().email().optional(),
  instagram_sid: z.string().optional(),
  tags: z.array(z.string()).default([]),
  metadata: z.record(z.unknown()).default({}),
  enabled: z.boolean().default(true),
}).refine(
  (data) => data.phone || data.email || data.instagram_sid,
  { message: 'At least one channel (phone, email, or instagram_sid) is required' }
);

export const updateContactBody = z.object({
  contact_name: z.string().min(1).optional(),
  phone: z.string().nullable().optional(),
  email: z.string().email().nullable().optional(),
  instagram_sid: z.string().nullable().optional(),
  tags: z.array(z.string()).optional(),
  metadata: z.record(z.unknown()).optional(),
  enabled: z.boolean().optional(),
});

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface OutboundContact {
  contact_id: string;
  // `hub_id` is routing input, not a stored column — the row never carries it
  // back (gh report d8a03f45). Kept for now because consumers read it off the
  // request context; do not add a write-side field here without a column.
  hub_id: string;
  contact_name: string;
  phone: string | null;
  email: string | null;
  instagram_sid: string | null;
  tags: string[];
  metadata: Record<string, unknown>;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface ListContactsResponse {
  contacts: OutboundContact[];
  total: number;
  page: number;
  per_page: number;
}

export interface CreateContactResponse {
  contact_id: string;
}
